module.exports = __webpack_public_path__ + "static/media/17pic.d6b0b43c.jpg";